import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(err => err)
};

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "layout" */ '@/views/user.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "layout" */ '@/views/user.vue'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/saleBillDetial',
    name: 'SaleBillDetial',
    component: () => import(/* webpackChunkName: "login" */ '@/views/saleBillDetial.vue'),
    meta: {
      keepAlive: false,
    }
  },
  {
    path: '/receiptBillDetail',
    name: 'ReceiptBillDetail',
    component: () => import(/* webpackChunkName: "login" */ '@/views/receiptBillDetail.vue'),
    meta: {
      keepAlive: false,
    }
  },
  {
    path: '/goodsChangeBill',
    name: 'GoodsChangeBill',
    component: () => import(/* webpackChunkName: "login" */ '@/views/goodsChangeBill.vue'),
    meta: {
      keepAlive: false,
    }
  },
  {
    path: '/goodsReturnBill',
    name: 'GoodsReturnBill',
    component: () => import(/* webpackChunkName: "login" */ '@/views/goodsReturnBill.vue'),
    meta: {
      keepAlive: false,
    }
  },
  {
    path: '/combineBill',
    name: 'CombineBill',
    component: () => import(/* webpackChunkName: "login" */ '@/views/combineBill.vue'),
    meta: {
      keepAlive: false,
    }
  },
]


const router = new VueRouter({
  scrollBehavior() {
    document.getElementById('app').scrollTop = 0
  },
  routes,
})

router.afterEach((to, from) => {
  store.commit('setPreviousRoute', from.name);
})

export default router
